export default __webpack_public_path__ + "static/media/reduce-amount.da0c8ba4.svg";